/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Asse semantico dell\'attributo del form esercente dichiarato dal bando
 */
export enum BindingTargetEsercente {

    SYSTEM_ESERCENTE_RAGIONE_SOCIALE = 'SYSTEM_ESERCENTE_RAGIONE_SOCIALE',

    SYSTEM_ESERCENTE_PARTITA_IVA = 'SYSTEM_ESERCENTE_PARTITA_IVA',

    SYSTEM_ESERCENTE_SEDE_LEGALE = 'SYSTEM_ESERCENTE_SEDE_LEGALE',

    SYSTEM_ESERCENTE_INDIRIZZO_SEDE = 'SYSTEM_ESERCENTE_INDIRIZZO_SEDE',

    SYSTEM_ESERCENTE_CCIAA = 'SYSTEM_ESERCENTE_CCIAA',

    SYSTEM_ESERCENTE_PEC = 'SYSTEM_ESERCENTE_PEC',

    SYSTEM_ESERCENTE_IBAN = 'SYSTEM_ESERCENTE_IBAN',

    FILE_DOCUMENTO = 'FILE_DOCUMENTO',

    CUSTOM_STRING = 'CUSTOM_STRING',

    CUSTOM_NUMBER = 'CUSTOM_NUMBER',

    CUSTOM_DATE = 'CUSTOM_DATE',

    CUSTOM_BOOLEAN = 'CUSTOM_BOOLEAN',

    CUSTOM_SINGLE_CHOICE = 'CUSTOM_SINGLE_CHOICE',

    CUSTOM_MULTIPLE_CHOICE = 'CUSTOM_MULTIPLE_CHOICE'
}

